<template>
  <v-form
  class="pa-6"
    ref="form"
    v-model="valid"
    lazy-validation>

    <h3 class="text-left mb-1 text-primary">List Certificates</h3>
    <p class="text-caption mb-4">Lista los certificados disponibles en Alison Desktop.</p>
    <div class="d-flex ga-2 mb-6">
      <v-btn
          size="small"
          :disabled="!valid"
          color="primary"
          @click="validate"
      >Certificate List >></v-btn>
    </div>

    <v-divider class="my-6"></v-divider>

    <v-row>
      <v-col cols="12">
        <vue-json-pretty :rootPath="'res'" :data=this.result> </vue-json-pretty>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';

import { mapMutations } from 'vuex'
import alisonJS from  '@/services/alison_js.js'

  export default  {
    components: {
      VueJsonPretty,
    },
    data: () => ({
      certificateList: null,
      valid: true,
      result: ''
    }),
    methods: {
      ...mapMutations({
        setSnack: 'setSnack',
        setColor: 'setColor'
      }),
      validate () {
        if (this.$refs.form.validate()) {
          this.getCertificateList()
        }
      },
      getCertificateList() {
          alisonJS.certificateList().then((cert) => {
              this.setColor('success')
              this.setSnack('Certificates obtained successfully')
              this.result = cert
              this.certificateList = JSON.stringify(cert, null, "\t");
              let certificates = cert.certificates
              this.$emit('enableTab', ['Sign'])
              this.$emit('setCertificateList', certificates)
          }).catch((e)=>{
            this.setColor('error')
            if(e.code && (e.detail || e.message)){
              if(e.message){ this.setSnack('ERROR ' + e.message) }
              else { this.setSnack('ERROR '+ e.code +': ' + e.detail) }
            }else{
              this.setSnack('FAILURE: ' + JSON.stringify(e))
            }
            this.certificateList = JSON.stringify(e, null, "\t");
          })
      }
    },
  }
</script>
